export default "/_next/static/images/img2-cdc8aba8a210338381464a417c6f7451.png";